import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import { COLORS, FONTSIZE, FONTWEIGHT, CONSTANTS } from "helpers/designConstants";

const countGroups = (sections) => {
  if (!sections) return 0;
  return sections.reduce(
    (sum, s) => sum + 1 + (s.groups ? countGroups(s.groups) : 0),
    0
  );
};

const TemplateCataloguePicker = ({ catalogues = [], onSelect, excludeID }) => {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    const custom = catalogues.filter(
      (c) => c.groupingMode === "custom" && c.id !== excludeID
    );
    if (!search.trim()) return custom;
    const lower = search.toLowerCase();
    return custom.filter((c) => c.name?.toLowerCase().includes(lower));
  }, [catalogues, excludeID, search]);

  return (
    <Wrapper>
      <SearchInput
        type='text'
        placeholder={t("search_catalogues") || "Search catalogues…"}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        autoFocus
      />
      <List>
        {filtered.length === 0 && (
          <EmptyMessage>
            {t("no_custom_catalogues_found") || "No custom catalogues found"}
          </EmptyMessage>
        )}
        {filtered.map((cat) => (
          <Item key={cat.id} onClick={() => onSelect(cat)}>
            <ItemName>{cat.name}</ItemName>
            <ItemMeta>
              {countGroups(cat.customSections)} {t("groups") || "groups"}
            </ItemMeta>
          </Item>
        ))}
      </List>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid ${COLORS.secondary};
  border-radius: ${CONSTANTS.borderRadius};
  font-size: ${FONTSIZE.small};
  outline: none;
  &:focus {
    border-color: ${COLORS.primary};
  }
`;

const List = styled.div`
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid ${COLORS.secondary};
  border-radius: ${CONSTANTS.borderRadius};
`;

const EmptyMessage = styled.div`
  padding: 12px;
  color: ${COLORS.text};
  font-size: ${FONTSIZE.xsmall};
  text-align: center;
`;

const Item = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  &:hover {
    background: ${COLORS.tertiary};
  }
  & + & {
    border-top: 1px solid ${COLORS.secondary};
  }
`;

const ItemName = styled.div`
  font-size: ${FONTSIZE.small};
  font-weight: ${FONTWEIGHT.medium};
  color: ${COLORS.primary};
`;

const ItemMeta = styled.div`
  font-size: ${FONTSIZE.xsmall};
  color: ${COLORS.text};
  margin-top: 2px;
`;

export default TemplateCataloguePicker;
